import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./organisationteam.css";

export default function GallerySection() {
  const { i18n } = useTranslation();
  const [data, setData] = useState({});
  const [lightboxImage, setLightboxImage] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get("https://admin.cmpranesh-admk.com/api/getorganisationteams.php");
      setData(res.data);
    } catch (err) {
      console.error("Error fetching gallery:", err);
    }
  };

  const getLang = (item, field) => {
    return i18n.language === "ta" 
      ? item[field + "_ta"] 
      : item[field + "_en"];
  };

  return (
    <div className="galSection">

      {Object.keys(data).map((category, idx) => (
        <div key={idx}>
          {/* CATEGORY TITLE */}
          <h2 className="galSection-title">
  {i18n.language === "ta" 
    ? data[category][0]?.category_ta || category 
    : category
  }
</h2>
          <div className="galSection-grid">
            {data[category].map(item => (
              <div
                key={item.id}
                className="galSection-card"
                onClick={() => setLightboxImage(item.image)}
              >
                <img
                  src={`https://admin.cmpranesh-admk.com/uploads/organisationteams/${item.image}`}
                  alt=""
                  className="galSection-img"
                />

                <h3 className="galSection-imgTitle">
                  {getLang(item, "title")}
                </h3>

                <p className="galSection-imgSubtitle">
                  {getLang(item, "subtitle")}
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* LIGHTBOX */}
      {lightboxImage && (
        <div className="galSection-lightbox">
          <div className="galSection-lightbox-content">
            <button
              className="galSection-lightbox-close"
              onClick={() => setLightboxImage(null)}
            >
              ✕
            </button>

            <img
              src={`http://localhost:5000/uploads/organisationteams/${lightboxImage}`}
              className="galSection-lightbox-img"
              alt=""
            />
          </div>
        </div>
      )}

    </div>
  );
}
